
import AppMonthSelect from "@/components/common/MonthSelect.vue";
import Vue from "vue";
import { IFrequencyObject } from "@/utils/frequency-object";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => IFrequencyObject,
			required: true
		},
		xs: {
			type: [String,Number],
			default: "12"
		},
		md: {
			type: [String, Number],
			default: "6"
		}
	},
	computed: {
		date():number {
			return parseInt(this.value.FrequencyMoment.split("/")[0]) || 1;
		},
		month():number {
			return parseInt(this.value.FrequencyMoment.split("/")[1]) || 1;
		}
	},
	methods: {
		setDate(value:number) {
			let split = this.value.FrequencyMoment.split("/");
			split[0] = `${value}`;
			this.value.FrequencyMoment = split.join("/");
		},
		setMonth(value:number) {
			let split = this.value.FrequencyMoment.split("/");
			split[1] = `${value}`;
			this.value.FrequencyMoment = split.join("/");
		}
	},
	components: {
		AppMonthSelect
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
